var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "同步日志详情", visible: _vm.isShow, width: "80%" },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "detail-content",
        },
        [
          _c("div", { staticClass: "detail-section" }, [
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [_vm._v("主键ID：")]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.fmt(_vm.detail.id))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [_vm._v("店铺ID：")]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.fmt(_vm.detail.storeId))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [_vm._v("客户ID：")]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.fmt(_vm.detail.customerId))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("同步类型："),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-value" },
                [
                  _vm.detail.syncType === "FULL"
                    ? _c(
                        "el-tag",
                        { attrs: { type: "primary", size: "small" } },
                        [_vm._v("全量同步")]
                      )
                    : _vm.detail.syncType === "INCREMENT"
                    ? _c(
                        "el-tag",
                        { attrs: { type: "success", size: "small" } },
                        [_vm._v("增量同步")]
                      )
                    : _vm.detail.syncType === "UPDATE"
                    ? _c(
                        "el-tag",
                        { attrs: { type: "warning", size: "small" } },
                        [_vm._v("修改同步")]
                      )
                    : _c("span", [_vm._v(_vm._s(_vm.detail.syncType || "-"))]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("同步批次ID："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.detail.syncBatchId || "-")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("同步状态："),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-value" },
                [
                  _c(
                    "el-tag",
                    { attrs: { type: _vm.statusTagType, size: "small" } },
                    [_vm._v(_vm._s(_vm.statusText))]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("同步开始时间："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.detail.syncStartTime || "-")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("同步结束时间："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.detail.syncEndTime || "-")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("同步总记录数："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.fmt(_vm.detail.totalCount))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("同步成功记录数："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.fmt(_vm.detail.successCount))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("同步失败记录数："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.fmt(_vm.detail.failCount))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("错误信息："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.detail.errorMessage || "-")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("创建时间："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.detail.createTime || "-")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-row" }, [
              _c("div", { staticClass: "detail-label" }, [
                _vm._v("更新时间："),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.detail.updateTime || "-")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "16px" } },
            [
              _c(
                "div",
                {
                  staticStyle: { "font-weight": "600", "margin-bottom": "8px" },
                },
                [_vm._v("失败详情")]
              ),
              _vm._v(" "),
              _vm.failDetailsList.length
                ? _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.failDetailsList,
                        size: "small",
                        border: "",
                        "max-height": "360",
                      },
                    },
                    _vm._l(_vm.failDetailColumns, function (col) {
                      return _c("el-table-column", {
                        key: col,
                        attrs: {
                          prop: col,
                          label: col,
                          "min-width": "140",
                          "show-overflow-tooltip": "",
                        },
                      })
                    }),
                    1
                  )
                : _c("div", { staticStyle: { color: "#909399" } }, [
                    _vm._v("-"),
                  ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.close } },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }